
oyc.svgChange = {
   init: function () {
       $('img.changed-svg').each(function(){
           var $img = $(this);
           var imgID = $img.attr('id');
           var imgClass = $img.attr('class');
           var imgURL = $img.attr('src');
           var imgHeight = $img.attr('height');
           var imgWidth = $img.attr('width');

           $.get(imgURL, function(data) {
               // Get the SVG tag, ignore the rest
               var $svg = $(data).find('svg');

               // Add replaced image's ID to the new SVG
               if(typeof imgID !== 'undefined') {
                   $svg = $svg.attr('id', imgID);
               }
               // Add replaced image's classes to the new SVG
               if(typeof imgClass !== 'undefined') {
                   $svg = $svg.attr('class', imgClass+' replaced-svg');
               }
               // Add replaced image's height to the new SVG
               if(typeof imgHeight !== 'undefined') {
                   $svg = $svg.attr('height', imgHeight);
               }
               // Add replaced image's width to the new SVG
               if(typeof imgWidth !== 'undefined') {
                   $svg = $svg.attr('width', imgWidth);
               }

               // Remove any invalid XML tags as per http://validator.w3.org
               $svg = $svg.removeAttr('xmlns:a');

               // Replace image with new SVG
               $img.replaceWith($svg);

           }, 'xml');
       });
   }
}
